import {createContext} from 'react';

import {sentryLogger} from '../sentryLogger';
import type {Logger} from '../../Logger';

const defaultLogger = sentryLogger();

const LoggerContext = createContext<Logger | null>(defaultLogger);

export {LoggerContext};
